import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link as RouteLink } from 'react-router-dom';

import Typography from 'antd/es/typography';

import colors from 'config/colors';

export const Text = React.forwardRef((props, ref) => {
  const { color, bgColor, children, style = {}, ...extra } = props;
  const styles = {
    color: colors.get(color) || color,
    backgroundColor: colors.get(bgColor) || bgColor,
    ...style,
  };

  return <Typography.Text style={styles} ref={ref} {...extra}>
    {children}
  </Typography.Text>
});

export const Title = React.forwardRef((props, ref) => {
  const { color, bgColor, children, ...extra } = props;
  const styles = {
    color: colors.get(color) || color,
    backgroundColor: colors.get(bgColor) || bgColor,
  };

  return <Typography.Title style={styles} {...extra} ref={ref}>
    {children}
  </Typography.Title>
});

export const Link = React.forwardRef(({ to, target, children, ...props }, ref) => (
  <RouteLink to={to} target={target}>
    <Text color="primary" {...props} ref={ref}>
      {children}
    </Text>
  </RouteLink>
));

const dots = keyframes`
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
  }
  40% {
    color: inherit;
    text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0);
  }
  60% {
    text-shadow: .25em 0 0, .5em 0 0 rgba(0,0,0,0);
  }
  80%, 100% {
    text-shadow: .25em 0 0, .5em 0 0;
  }
`;

export const LoadingText = styled(Text)`
  &:after {
    content: '.';
    animation: ${dots} 2s steps(5, end) infinite;
  }
`;